<template>
	<!-- 자동완성 start -->
	<ul id="auto_complete" class="auto_complete">
		<template v-if="content && autoCompleteShow">
			<li v-for="(autoCmpl, index) in autoCompleteList" :key="index">
				<a
					href="#"
					:class="{ on: index === acLine - 1 }"
					@click.prevent.stop="clickMessage(autoCmpl.text)"
					v-html="autoCmpl.htmlText"
					><!--{{ autoCmpl.text }}--></a
				>
			</li>
		</template>
	</ul>
	<!--// 자동완성 end -->
</template>
<script>
import EventBus from '../eventBus/eventBus';
import config from '../config/config.json';
export default {
	name: 'AutoComplete',
	props: {
		userInfo: {
			type: Object,
			default: null,
			required: false,
		},
		content: {
			type: String,
			default: null,
			required: false,
		},
		autoCompleteShow: {
			type: Boolean,
			default: false,
			required: false,
		},
		writingDisable: {
			type: Boolean,
			default: false,
			required: false,
		},
	},
	data() {
		return {
			autoCompleteList: [],
			contentCp: '',
			acLine: 0,
		};
	},
	created() {
		EventBus.$on('autoCompList', data => {
			this.autoCompList(data);
		});
	},
	watch: {
		content: function() {
			if (this.content.length > 0 && this.content !== this.contentCp) {
				this.getAutoCompleteList();
				this.contentCp = this.content;
			}
		},
	},
	methods: {
		getAutoCompleteList() {
			///////////// local ///////////////////
			// this.autoCompleteList = [
			//   {
			//     text: '대장암'
			//   },
			//   {
			//     text: '대장암 수술'
			//   },
			//   {
			//     text: '대장암 증상'
			//   }
			// ];

			// this.autoCompleteList.forEach(autoComp => {
			//   autoComp.htmlText = autoComp.text.replace(this.content, '<span>' + this.content + '</span>');
			// });
			// this.acLine = this.autoCompleteList.length + 1;
			/////////////////////////////////////////

			this.$axios
				.post(config.REST_API_PATH + '/chat/autocomplete', {
					agentName: this.userInfo.agentName,
					query: this.content,
					repoId: this.userInfo.repoId,
					userId: this.userInfo.userId,
				})
				.then(response => {
					this.autoCompleteList = response.data.messages;
					this.autoCompleteList.forEach(autoComp => {
						autoComp.htmlText = autoComp.text.replace(
							this.content,
							'<span>' + this.content + '</span>',
						);
					});
					this.acLine = this.autoCompleteList.length + 1;
				})
				.catch(error => {
					console.log(error);
				});
		},
		clickMessage(query) {
			if (this.writingDisable) {
				alert('이전 질문에 대한 답변을 처리중입니다.');
			} else {
				this.$emit('msgClick', query, query);
			}
		},
		autoCompList(e) {
			if (this.content) {
				if (
					e.keyCode == 13 ||
					e.which == 13 ||
					e.keyCode == 0 ||
					e.which == 0
				) {
					if (!this.writingDisable) {
						const autoContent = this.autoCompleteList[this.acLine - 1];
						autoContent
							? this.clickMessage(autoContent.text)
							: this.clickMessage(this.content);
					}
					return;
				} else if (
					e.keyCode == 40 ||
					e.which == 40 ||
					e.keyCode == 38 ||
					e.which == 38 ||
					e.shiftKey ||
					e.keyCode == 9
				) {
					if (this.autoCompleteList.length > 0) {
						if (
							e.keyCode == 40 ||
							e.which == 40 ||
							(e.shiftKey && e.keyCode == 9)
						) {
							// Down & Shift+Tab

							if (this.acLine < this.autoCompleteList.length + 1) {
								// e.preventDefault();
								this.acLine++;
							} else {
								// eslint-disable-next-line no-undef
								$('#send_input').val(this.content);
							}
						} else if (e.keyCode == 38 || e.which == 38 || e.keyCode == 9) {
							// Up or Tab

							// e.preventDefault();

							if (this.acLine > 1) {
								this.acLine--;
							}
						}
						this.autoCompleteList.forEach((autoComp, index) => {
							if (index + 1 == this.acLine) {
								// eslint-disable-next-line no-undef
								$('#send_input').val(autoComp.text);
							}
						});
					} else {
						this.acLine = this.autoCompleteList.length + 1;
					}
				} else {
					this.acLine = this.autoCompleteList.length + 1;
				}
			}
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/AutoComplete.vue